module.exports = __webpack_public_path__ + "img/19.451fb33c.webp";